import { DepositType, PurchaserType } from "../../../SideDrawer/sideTypes";
import { runInnerFunction } from "../../../compatManager";
import { RPWDataReader } from "../../../livedataFuncs";
import { store } from "../../../redux/store";
import { copyAttributes, copyNodes } from "../../../util/rpwCommonFuncs";
import { LoadMunicByName, ResetMunicRecord } from "../../../util/rpwPropertyFuncs";
import { DRImportFieldType, DRImportSectionType } from "./DRImportConfig";

export function validateRequiredFields(def: DRImportSectionType | DRImportFieldType, processor: RPWDataReader, drProcessor: RPWDataReader): boolean {
    const condition = def.requiredFields;
    if (condition) {
        for (let i = 0; i < condition.length; i++) {
            const value = condition[i].isOtherSide ? drProcessor[condition[i].field]() : processor[condition[i].field]();
            if (condition[i].value) {
                let temp = value === condition[i].value;
                if (!temp) {
                    return false;
                }
            } else if (!value) {
                return false;
            }
        }
    }
    return true;
}


export class SellerImport {
    static getSellerNameOnAgreement(dataReader: RPWDataReader): string {
        const nodes = dataReader.getSellerPeopleInfo();
        if (dataReader.getAppCode() === "BC") return nodes[0]?.OnAgreementName;
        return nodes[0]?.Name;
    }

    static getSellerNameOnTitle(dataReader: RPWDataReader): string {
        const nodes = dataReader.getSellerPeopleInfo();
        if (dataReader.getAppCode() === "BC") return nodes[0]?.Name;
        return nodes[0]?.TransferorName;
    }
    
    static getSellerGender(dataReader: RPWDataReader): string {
        const nodes = dataReader.getSellerPeopleInfo();
        return nodes[0]?.Gender;
    }
    static getSellerHSTNumber(dataReader: RPWDataReader): string {
        const nodes = dataReader.getSellerPeopleInfo();
        return nodes[0]?.HSTNumber;
    }
    static getSellerAddressForService(dataReader: RPWDataReader): string {
        const nodes = dataReader.getSellerPeopleInfo();
        const addrStr = nodes[0]?.AddressForService;
        const regex = /[a-zA-Z0-9]/;
        return regex.test(addrStr) ? addrStr : null;
    }
    static setSellerNameOnAgreement(srcDataReader: any, destDataReader: any) {
        const val = srcDataReader.livedataRoot.selectSingleNode("Vendor[@IsVendor='1']")?.getAttribute("Name");
        // set first seller
        if (destDataReader.getAppCode() === "ON") {
            const vendorNode = destDataReader.livedataRoot.selectSingleNode("Vendor[@IsVendor='1']");
            if (vendorNode) {
                vendorNode.setAttribute("Name", val);
            } else {
                destDataReader.addNewVendor(val);
            }
        } else {
            // BC, APSNames node
            const vendorNode = destDataReader.livedataRoot.selectSingleNode("APSNames[@Type='Vendors']/Name[(string-length(@OnTitleName) > 0) or (string-length(@OnAgreementName) > 0)]") ?? destDataReader.addNewVendor(val);
            if (vendorNode) {
                vendorNode.setAttribute("OnAgreementName", val);
                vendorNode.setAttribute("OnAgreementLastName", val);
            }
        }
        runInnerFunction("SetPageDirty", null);
    }
    static setSellerNameOnTitle(srcDataReader: any, destDataReader: any) {
        SellerImport.setSellerNameOnAgreement(srcDataReader, destDataReader);
        const val = srcDataReader.livedataRoot.selectSingleNode("Vendor[@IsVendor='1']")?.getAttribute("TransferorName");
        // set first seller
        if (destDataReader.getAppCode() === "ON") {
            const vendorNode = destDataReader.livedataRoot.selectSingleNode("Vendor[@IsVendor='1']") ?? destDataReader.addNewVendor(srcDataReader.livedataRoot.selectSingleNode("Vendor[@IsVendor='1']")?.getAttribute("Name"));
            vendorNode.setAttribute("TransferorName", val);
            vendorNode.setAttribute("isTransferorNameOverWrite", "1");
        } else {
            // BC, APSNames node
            const vendorNode = destDataReader.livedataRoot.selectSingleNode("APSNames[@Type='Vendors']/Name[(string-length(@OnTitleName) > 0) or (string-length(@OnAgreementName) > 0)]") ?? destDataReader.addNewVendor(val);
            if (vendorNode) {
                vendorNode.setAttribute("OnTitleName", val);
                vendorNode.setAttribute("OnTitleLastName", val);
                vendorNode.setAttribute("OnTitleNameFull", val);
                vendorNode.setAttribute("isOnTitleLastNameOverWrite", "1");
            }
        }
        runInnerFunction("SetPageDirty", null);
    }
    static setSellerGender(srcDataReader: any, destDataReader: any) {
        SellerImport.setSellerNameOnAgreement(srcDataReader, destDataReader);
        const val = srcDataReader.livedataRoot.selectSingleNode("Vendor[@IsVendor='1']")?.getAttribute("Gender");
        let vendorNode;
        // set first seller
        if (destDataReader.getAppCode() === "ON") {
            vendorNode = destDataReader.livedataRoot.selectSingleNode("Vendor[@IsVendor='1']") ?? destDataReader.addNewVendor(srcDataReader.livedataRoot.selectSingleNode("Vendor[@IsVendor='1']")?.getAttribute("Name"));
        } else {
            // BC, APSNames node
            vendorNode = destDataReader.livedataRoot.selectSingleNode("APSNames[@Type='Vendors']/Name[(string-length(@OnTitleName) > 0) or (string-length(@OnAgreementName) > 0)]") ?? destDataReader.addNewVendor(val);
        }
        if (vendorNode) {
            vendorNode.setAttribute("Gender", val);
            runInnerFunction("SetPageDirty", null);
        }
    }
    static setSellerHSTNumber(srcDataReader: any, destDataReader: any) {
        SellerImport.setSellerNameOnAgreement(srcDataReader, destDataReader);
        const val = srcDataReader.livedataRoot.selectSingleNode("Vendor[@IsVendor='1']")?.getAttribute("GSTNumber");
        let vendorNode;
        // set first seller
        if (destDataReader.getAppCode() === "ON") {
            vendorNode = destDataReader.livedataRoot.selectSingleNode("Vendor[@IsVendor='1']") ?? destDataReader.addNewVendor(srcDataReader.livedataRoot.selectSingleNode("Vendor[@IsVendor='1']")?.getAttribute("Name"));
        } else {
            // BC, APSNames node
            vendorNode = destDataReader.livedataRoot.selectSingleNode("APSNames[@Type='Vendors']/Name[(string-length(@OnTitleName) > 0) or (string-length(@OnAgreementName) > 0)]") ?? destDataReader.addNewVendor(val);
        }
        if (vendorNode) {
            vendorNode.setAttribute("GSTNumber", val);
            runInnerFunction("SetPageDirty", null);
        }
    }
    static setSellerAddressForService(srcDataReader: any, destDataReader: any) {
        SellerImport.setSellerNameOnAgreement(srcDataReader, destDataReader);
        const val = srcDataReader.livedataRoot.selectSingleNode("Vendor[@IsVendor='1']")?.getAttribute("AddressForService");
        let vendorNode;
        // set first seller
        if (destDataReader.getAppCode() === "ON") {
            vendorNode = destDataReader.livedataRoot.selectSingleNode("Vendor[@IsVendor='1']") ?? destDataReader.addNewVendor(srcDataReader.livedataRoot.selectSingleNode("Vendor[@IsVendor='1']")?.getAttribute("Name"));
            if (vendorNode) {
                vendorNode.setAttribute("AddressForService", val);
                vendorNode.setAttribute("isAddressForServiceOverWrite", "1");
                runInnerFunction("SetPageDirty", null);
            }
        } else {
            // BC, APSNames node
            vendorNode = destDataReader.livedataRoot.selectSingleNode("APSNames[@Type='Vendors']/Name[(string-length(@OnTitleName) > 0) or (string-length(@OnAgreementName) > 0)]") ?? destDataReader.addNewVendor(val);
            if (vendorNode) {
                const arr = runInnerFunction("ParseAddressAdvanced", val);
                vendorNode.setAttribute("AddressForService", val);
                vendorNode.setAttribute("StreetAddress", (arr[1] ? (arr[1] + " - ") : "") + arr[2] + arr[3] + " " + arr[4]);
                vendorNode.setAttribute("City", arr[5]);
                vendorNode.setAttribute("Province", arr[6]);
                vendorNode.setAttribute("PostalCode", arr[7]);
                vendorNode.setAttribute("Country", arr[14]);
                vendorNode.setAttribute("isAddressForServiceOverWrite", "1");
                vendorNode.setAttribute("isStreetAddressOverWrite", "1");
                vendorNode.setAttribute("isCityOverWrite", "1");
                vendorNode.setAttribute("isProvinceOverWrite", "1");
                vendorNode.setAttribute("isPostalCodeOverWrite", "1");
                vendorNode.setAttribute("isCountryOverWrite", "1");
                runInnerFunction("SetPageDirty", null);
            }
        }
    }
}

export class BuyerImport {
    static getBuyerNameOnAgreement(buyerInfo: PurchaserType): string {
        return buyerInfo?.Name;
    }
    
    static getBuyerNameOnTitle(buyerInfo: PurchaserType): string {
        return buyerInfo?.TransfereeName;
    }
    static getBuyerBirthday(buyerInfo: PurchaserType): string {
        return buyerInfo?.Birthday;
    }
    static getBuyerGender(buyerInfo: PurchaserType): string {
        return buyerInfo?.Gender;
    }
    static getBuyerAddressForService(buyerInfo: PurchaserType): string {
        return buyerInfo?.AddressForService;
    }
    static setBuyer(srcDataReader: RPWDataReader, destDataReader: RPWDataReader) {
        const state = store.getState();
        const ApplicationSubCode = state.SessionInfo.ApplicationSubCode;
        let NodesToCopyString = "";
        let AttributesToCopyString = "";
		if (ApplicationSubCode == 'SK' || ApplicationSubCode == 'BC' || ApplicationSubCode == 'MB' || ApplicationSubCode == 'NS') {
			NodesToCopyString += 'APSNames';
			AttributesToCopyString += ApplicationSubCode == 'NS' ? ",Purchasers,ClientName,PurchaserAddress":",Purchasers,XFeeName,PurchaserAddress";
		} else {
			NodesToCopyString += "Purchaser";
			AttributesToCopyString += ",Purchasers,XFeeName,PurchaserAddress";
		}
        copyNodes(srcDataReader, destDataReader, NodesToCopyString);
        copyAttributes(srcDataReader, destDataReader, AttributesToCopyString);
        runInnerFunction("SetPageDirty", null);
    }
    static setBuyers(srcDataReader: any, destDataReader: any) {
        const state = store.getState();
        const appProvinceShort = state.SessionInfo.appProvinceShort;
        let NodesToCopyString = "";
        let AttributesToCopyString = "";
		if (["SK", "BC", "MB", "NS"].includes(appProvinceShort)) {
			NodesToCopyString += 'TransfereeDetails';
			AttributesToCopyString += appProvinceShort == 'NS' ? ",Purchasers,ClientName,PurchaserAddress":",Purchasers,XFeeName,PurchaserAddress";
            destDataReader.livedataRoot.selectSingleNode("APSNames[@Type='Purchasers']").removeAttribute("CustomAddressee");
            destDataReader.livedataRoot.selectSingleNode("APSNames[@Type='Purchasers']").removeAttribute("ClientSalutation");
		} else {
			NodesToCopyString += "Purchaser";
			AttributesToCopyString += ",Purchasers,XFeeName,PurchaserAddress";
            destDataReader.livedataRoot.removeAttribute("CustomPurchaserAddressee");
            destDataReader.livedataRoot.removeAttribute("ClientSalutation");
		}
        copyAttributes(srcDataReader, destDataReader, AttributesToCopyString);
        destDataReader.deleteNodes("PurchaserBankingInfo");
        destDataReader.deleteNodes(NodesToCopyString);

        const newBuyerNodes = srcDataReader.getXMLList(NodesToCopyString);
        for (let i = 0; i < newBuyerNodes.length; i++) {
            destDataReader.addNewPurchaser();
            let purchaserNode;
            let PurchaserAttributesToCopyString = "";
            if (["SK", "BC", "MB", "NS"].includes(appProvinceShort)) {
                purchaserNode = destDataReader.livedataRoot.selectSingleNode(`APSNames[@Type='Purchasers']/Name[@OnAgreementName='' or not(@OnAgreementName)]`);
                let identification = purchaserNode.selectSingleNode("Identification") ?? purchaserNode.ownerDocument.createElement("Identification");
                const name = newBuyerNodes[i].getAttribute("TransfereeName") ?? "";
                const gender = newBuyerNodes[i].getAttribute("Gender") ?? "";
                const birthday = newBuyerNodes[i].getAttribute("BirthDate") ?? "";
                const address = newBuyerNodes[i].getAttribute("AddressForService") ?? "";
                const addressArr = runInnerFunction("ParseAddressAdvanced", address);

                const purchaserNodeAttr = [
                    ["OnAgreementName", name],
                    ["OnAgreementLastName", name],
                    ["OnAgreementNameFull", name],
                    ["OnTitleName", name],
                    ["OnTitleLastName", name],
                    ["OnTitleNameFull", name],
                    ["isOnTitleLastNameOverWrite", "1"],
                    ["Gender", gender],
                    ["AddressForService", address],
                    ["StreetAddress", (addressArr[1] ? (addressArr[1] + " - ") : "") + addressArr[2] + addressArr[3] + " " + addressArr[4]],
                    ["City", addressArr[5]],
                    ["Province", addressArr[6]],
                    ["PostalCode", addressArr[7]],
                    ["Country", addressArr[14]],
                    ["isAddressForServiceOverWrite", "1"],
                    ["isStreetAddressOverWrite", "1"],
                    ["isCityOverWrite", "1"],
                    ["isProvinceOverWrite", "1"],
                    ["isPostalCodeOverWrite", "1"],
                    ["isCountryOverWrite", "1"],
                ]
                const identificationNodeAttr = [
                    ["Name", name],
                    ["BirthDate", birthday],
                ]

                purchaserNodeAttr.forEach(([attrName, attrValue]) => {
                    purchaserNode.setAttribute(attrName, attrValue);
                })
                identificationNodeAttr.forEach(([attrName, attrValue]) => {
                    identification.setAttribute(attrName, attrValue);
                })
            } else {
                purchaserNode = destDataReader.livedataRoot.selectSingleNode(`Purchaser[(@Name='' or not(@Name)) and @IsPurchaser='1']`);
                PurchaserAttributesToCopyString += "Name,TransfereeName,TransfereeNameFull,PurchaserNameFull,BirthDate,Gender,AddressForService";
                for (let attr of PurchaserAttributesToCopyString.split(",")) {
                    const attrVal = newBuyerNodes[i].getAttribute(attr);
                    if (attrVal) {
                        purchaserNode.setAttribute(attr, attrVal);
                    }
                }
                if (purchaserNode.getAttribute("AddressForService")) {
                    purchaserNode.setAttribute("isAddressForServiceOverWrite", "1");
                }
            }
        }

        runInnerFunction("SetPageDirty", null);
    }
}

export class ContractImport {
    // getters
    static getClosingDate(dataReader: RPWDataReader): string {
        return dataReader.getClosingDate();
    }
    static getInterimClosingDate(dataReader: RPWDataReader): string {
        return dataReader.getInterimClosingDate();
    }
    static getContractDate(dataReader: RPWDataReader): string {
        return dataReader.getContractDate();
    }
    static getContractPrice(dataReader: RPWDataReader): string {
        return dataReader.getContractPrice();
    }
    static getIncludeHST(dataReader: RPWDataReader): string {
        return dataReader.getIncludeHST();
    }
    static getConsideration(dataReader: RPWDataReader): string {
        return dataReader.getConsideration();
    }
    static getConsiderationEreg(dataReader: RPWDataReader): string {
        return dataReader.getConsiderationEreg();
    }
    static getTarionEnrolDate(dataReader: RPWDataReader): string {
        return dataReader.getTarionEnrolDate();
    }
    static getPurchaserEntitledHSTRebate(dataReader: any): string {
        return dataReader.livedataRoot.getAttribute("EntitledToGSTRebate");
    }
    static getBDOC(dataReader: RPWDataReader): string {
        let bdocVal = String(dataReader.getFinancialInformation().adjustment.bdoc);
        if (!bdocVal) return null;
        let bdoc = String(bdocVal);
        return bdoc;
    }
    static getInterimBDOC(dataReader: RPWDataReader): string {
        const bdocVal = dataReader.getFinancialInformation().interimAdjustment.interimBDOC;
        if (!bdocVal) return null;
        let bdoc = String(bdocVal);
        return bdoc;
    }
    static getUpgrades(dataReader: any): string {
        return dataReader.livedataRoot.getAttribute("TotalAllUpgrades");
    }

    // setters
    static setClosingDate(srcDataReader: RPWDataReader, destDataReader: RPWDataReader) {
        destDataReader.setClosingDate(srcDataReader.getClosingDate());
    }
    static setInterimClosingDate(srcDataReader: RPWDataReader, destDataReader: RPWDataReader) {
        copyAttributes(srcDataReader, destDataReader, "PropertyType,NewHome");
        destDataReader.setInterimClosingDate(ContractImport.getInterimClosingDate(srcDataReader));
    }
    static setContractDate(srcDataReader: RPWDataReader, destDataReader: RPWDataReader) {
        destDataReader.setContractDate(ContractImport.getContractDate(srcDataReader));
    }
    static setContractPrice(srcDataReader: RPWDataReader, destDataReader: RPWDataReader) {
        destDataReader.setContractPrice(ContractImport.getContractPrice(srcDataReader));
    }
    static setIncludeHST(srcDataReader: RPWDataReader, destDataReader: RPWDataReader) {
        destDataReader.setIncludeHST(ContractImport.getIncludeHST(srcDataReader));
    }
    static setConsideration(srcDataReader: RPWDataReader, destDataReader: RPWDataReader) {
        destDataReader.setConsideration(srcDataReader.getConsideration());
    }
    static setConsiderationEreg(srcDataReader: RPWDataReader, destDataReader: RPWDataReader) {
        destDataReader.setConsiderationEreg(srcDataReader.getConsiderationEreg());
    }
    static setTarionEnrolDate(srcDataReader: RPWDataReader, destDataReader: RPWDataReader) {
        destDataReader.setTarionEnrolDate(srcDataReader.getTarionEnrolDate());
    }
    static setPurchaserEntitledHSTRebate(srcDataReader: RPWDataReader, destDataReader: RPWDataReader) {
        const val = (srcDataReader as any).livedataRoot.getAttribute("EntitledToGSTRebate");
        destDataReader.setOtherAttribute("EntitledToGSTRebate", val);
        destDataReader.setOtherAttribute("EntitledToHSTRebate", val);
    }
    static setBDOC(srcDataReader: RPWDataReader, destDataReader: RPWDataReader) {
        const bdoc = ContractImport.getBDOC(srcDataReader);
        if (bdoc && bdoc > "") {
            destDataReader.setBDOC(bdoc);
        }
    }
    static setInterimBDOC(srcDataReader: RPWDataReader, destDataReader: RPWDataReader) {
        const bdoc = ContractImport.getInterimBDOC(srcDataReader);
        if (bdoc && bdoc > "") {
            destDataReader.setInterimBDOC(bdoc);
        }
    }
}

export class DepositImport {
    static getDepositTotal(dataReader: RPWDataReader): string {
        return dataReader.getDepositTotal();
    }
    static getDepositAmount(depositInfo: DepositType): string {
        return depositInfo?.Amount;
    }
    static setDeposits(srcDataReader: RPWDataReader, destDataReader: RPWDataReader) {
        destDataReader.setDeposits(srcDataReader.getXMLList("Deposit"))
    }
}

export class PropertyImport {
    static getAddress(dataReader: RPWDataReader): string {
        return dataReader.getPropertyAddress();
    }
    static getAssessmentRollNo(dataReader: RPWDataReader): string {
        return dataReader.getAssessmentRollNo();
    }
    static getLegalDesc(dataReader: RPWDataReader): string {
        if (dataReader.getAppCode() === "BC" || (dataReader as any).livedataRoot.selectSingleNode("Project")?.getAttribute("RealAppCodeProject") === "RPWCPBC") {
            return (dataReader as any).livedataRoot.selectSingleNode("LegalDescriptionInput").getAttribute("LongLegalDescription");
        }
        return dataReader.getLegalDesc();
    }
    static getPropertyType(dataReader: RPWDataReader): string {
        return dataReader.getPropertyType();
    }
    static async setAddress(srcDataReader: RPWDataReader, destDataReader: RPWDataReader) {
        // copy attributes
        const attributes = "County,LandRegistryOffice,CondoCorp,CondoCorpShort,CondoCorpNumber,PropertyAddress,,twCommonElements,IsEReg,NewHome,DevelopmentTown";
        const nodesToCopy = "Property,munic,CondoContact";
        copyAttributes(srcDataReader, destDataReader, attributes);
        // copy nodes
        copyNodes(srcDataReader, destDataReader, nodesToCopy);
        // load munic data
        var municipality = "";
        var MunicNode = (destDataReader as any).livedataRoot.selectSingleNode("munic");

        if (MunicNode != null)
            municipality = MunicNode.getAttribute("Name");

        if (municipality == null || municipality == "")
            municipality = (srcDataReader as any).livedataRoot.getAttribute("DevelopmentTown");

        if(municipality != null && municipality != "")
        {
            const state = store.getState();
            if(await LoadMunicByName(municipality, (destDataReader as any).livedataRoot, state.SessionID))
                ResetMunicRecord((destDataReader as any).livedataRoot, state.SessionID);
            else
            {
                alert("Cannot load the information of municipality '" + municipality + "'");
                //	return; // cannot fail here should continue load others
            }
        }
    }
    static setAssessmentRollNo(srcDataReader: RPWDataReader, destDataReader: RPWDataReader) {
        // copy array of attributes
        const assessmentRollAttributes = "AssessmentRollNoCity,AssessmentRollNoMunicipality,AssessmentRollNoMap,AssessmentRollNoBlock,AssessmentRollNoParcel,AssessmentRollNoOther";
        copyAttributes(srcDataReader, destDataReader, assessmentRollAttributes);
    }
    static setLegalDesc(srcDataReader: RPWDataReader, destDataReader: RPWDataReader) {
        // property type goes with legal desc
        destDataReader.setPropertyType(srcDataReader.getPropertyType());
        copyAttributes(srcDataReader, destDataReader, "County,LandRegistryOffice,twCommonElements,CondoCorp,CondoCorpShort,CondoCorpNumber");
        destDataReader.setLegalDesc(srcDataReader.getXMLList("LegalDescriptionInput"));
    }
}

export class InterimImport {
    static getOccupancyFee(dataReader: RPWDataReader): string {
        return dataReader.getOtherAttribute("totalInterimFee");
    }
    static getRealtyTaxes(dataReader: RPWDataReader): string {
        return dataReader.getOtherAttribute("totalInterimTax");
    }
    static getCommonExpenses(dataReader: RPWDataReader): string {
        return dataReader.getOtherAttribute("totalInterimExpenses");
    }
    static getInterest(dataReader: RPWDataReader): string {
        // format to $1,000.00 (1%)
        const amount = dataReader.getOtherAttribute("BalanceOnClosingAtOccupancy");
        const rate = dataReader.getOtherAttribute("InterestBalanceClosing");
        function formatNumber(value) {
            return parseFloat(value).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 20 });
        }
        let formattedAmount = amount ? `$${formatNumber(amount)}` : "";
        let formattedRate = rate ? `${parseFloat(rate).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 20 })}%` : "";
        let result = formattedAmount + (formattedAmount && formattedRate ? ` (${formattedRate})` : formattedRate);
        return result;
    }
}

export class CondoImport {
    static getCondoCorpName(dataReader: RPWDataReader): string {
        return dataReader.getCondoCorpName();
    }
    static getCondoCorpNumber(dataReader: RPWDataReader): string {
        return dataReader.getCondoCorpNumber();
    }
    static getCondoCorpContactName(dataReader: RPWDataReader): string {
        return dataReader.getCondoCorpContactName();
    }
}